import { Modal } from "@/utils/bootstrap";
import SvgPhone from "./SvgPhone";
import SvgModalClose from "@/app/components/lib/SvgModalClose";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  phoneNumbers: string[];
}

const PhoneNumbersPopup: React.FC<Props> = ({
  show,
  setShow,
  phoneNumbers,
}) => {
  const t = useTranslation();
  return (
    <Modal
      centered
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="messagebox-dialog"
      contentClassName="messagebox-phones"
    >
      <div className="messagebox-closeicon">
        <SvgModalClose onClick={() => setShow(false)} />
      </div>
      <div className="messagebox-title">{t.call_us}</div>
      <div className="messagebox-message">{t.select_a_number}</div>
      <div className="text-center" style={{ overflowY: "auto" }}>
        {phoneNumbers?.map((ph, key) => (
          <a
            aria-label="Click to Call"
            href={`tel:${ph}`}
            target="_blank"
            rel="noopener noreferrer"
            key={key}
          >
            <button
              dir="ltr"
              className="messagebox-action-alone"
              style={{ marginBottom: 16 }}
              onClick={() => {
                setShow(false);
              }}
            >
              <SvgPhone />
              <span style={{ marginInlineStart: 16 }}>{ph}</span>
            </button>
          </a>
        ))}
        <div style={{ paddingBottom: 8 }} />
      </div>
    </Modal>
  );
};

export default PhoneNumbersPopup;
